import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.ManualJournalHeaderFields', {
    narration: 'Narration',
    narrationPlaceholder: 'Enter value',
    journalDate: 'Date',
    journalDatePlaceholder: 'Select date',
    showOnCashBasisReports: 'Show journal on cash basis reports',
    defaultNarration: 'Default narration to journal line description',
});
